import { render, staticRenderFns } from "./NewList.vue?vue&type=template&id=a78b5ea6&"
import script from "./NewList.vue?vue&type=script&lang=ts&"
export * from "./NewList.vue?vue&type=script&lang=ts&"
import style0 from "./NewList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports